export default [
  {
    path: '/questions',
    name: 'questions',
    component: () => import('@/views/questions/QuestionsList.vue'),
    meta: {
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/edit/:id',
    name: 'question-edit',
    component: () => import('@/views/questions/QuestionEdit.vue'),
    meta: {
      navActiveLink: 'questions',
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/suggest/frames/:movie_id',
    name: 'question-frames-suggest',
    component: () => import('@/views/questions/Suggest/GetMovieFrames.vue'),
    meta: {
      navActiveLink: 'questions',
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/suggest/actors/:movie_id',
    name: 'question-actors-suggest',
    component: () => import('@/views/questions/Suggest/GetMovieActors.vue'),
    meta: {
      navActiveLink: 'questions',
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/suggest/characters/:movie_id',
    name: 'question-characters-suggest',
    component: () => import('@/views/questions/Suggest/GetMovieCharacters.vue'),
    meta: {
      navActiveLink: 'questions',
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/suggest/character-name/:movie_id',
    name: 'question-character-name-suggest',
    component: () => import('@/views/questions/Suggest/GetCharacterName.vue'),
    meta: {
      navActiveLink: 'questions',
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/suggest/description/:movie_id',
    name: 'question-description-suggest',
    component: () => import('@/views/questions/Suggest/GetMovieDescription.vue'),
    meta: {
      navActiveLink: 'questions',
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/storage',
    name: 'question-storage',
    component: () => import('@/views/question-storage/QuestionStorageList.vue'),
    meta: {
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/storage/pack/:id',
    name: 'question-storage-pack',
    component: () => import('@/views/question-storage/StoragePackView.vue'),
    meta: {
      navActiveLink: 'question-storage',
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/storage/:id',
    name: 'question-storage-edit',
    component: () => import('@/views/question-storage/StorageQuestionEdit.vue'),
    meta: {
      navActiveLink: 'question-storage',
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/import',
    name: 'question-storage-import',
    component: () => import('@/views/question-storage/import/PackImport.vue'),
    meta: {
      resource: 'questions',
      action: 'view',
    },
  },
  {
    path: '/questions/mechanics',
    name: 'question-mechanics',
    component: () => import('@/views/question-storage/mechanics/MechanicsList.vue'),
    meta: {
      resource: 'questions',
      action: 'view',
    },
  },
]
